import { useContext } from 'react'

import AppSpinnerContext from 'context/AppSpinnerContext'

const useAppSpinnerContext = () => useContext(AppSpinnerContext)

export default useAppSpinnerContext